<template>
  <div class="checkout checkout-layout">
    <div class="checkout_header__top">
      <div class="container checkout_header__top-container">
        <AppUsps
          v-if="result?.data?.headerUsps?.[0]?.Usp?.length"
          class="checkout_header__usps"
          :usps="result?.data.headerUsps[0].Usp"
          horizontal
        />
      </div>
    </div>

    <header
      ref="header"
      class="checkout_header"
    >
      <div
        ref="wrapper"
        class="checkout_header__wrapper"
      >
        <div class="container checkout_header__container">
          <div class="checkout_header__help">
            <div class="checkout_header__help-heading heading heading--5">
              Hulp nodig?
            </div>
            <p class="checkout_header__help-description">
              Wij helpen je graag! Bel: <a href="tel:+32051269888">+32(0) 51 26 98 88</a>
            </p>
          </div>

          <AppLogo
            class="checkout_header__logo"
            color="black"
            data-testid="logo"
          />

          <div class="checkout__mini-cart">
            <CartMiniCart />
          </div>

          <CheckoutSteps class="checkout__steps" />
        </div>
      </div>
    </header>
  </div>
</template>

<script lang="ts" setup>
// import layoutQuery from '~layers/app/graphql/layout.gql'

const { public: config } = useRuntimeConfig()
// const { data } = await useAsyncQuery(layoutQuery, { locale: config.strapiLocale })
const { data: result } = await useAsyncGraphqlQuery('layout', {
  locale: config.strapiLocale,
}, useGraphqlDefaultClient())
</script>

<!-- <style src="~layers/app/components/Checkout/Header.css" /> -->
<style>
@import url("~layers/app/components/Checkout/Header.css");
</style>
